import axios from "axios";

import {
  handleChangeRequestHeader,
  handleConfigureAuth,
  handleAuthError,
  handleGeneralError,
  handleNetworkError,
} from "./tools";


axios.interceptors.request.use((config) => {
  config = handleChangeRequestHeader(config);
  config = handleConfigureAuth(config);
  return config;
});

axios.interceptors.response.use(
  (response) => {
    if (response.status !== 200) return Promise.reject(response.data);
    // handleAuthError(response.data.errno);
    handleGeneralError(response.data.code, response.data.msg);
    return response;
  },
  (err) => {
    const status = err && err.response && err.response.status ? err.response.status : 0
    handleNetworkError(status);
    return Promise.reject(err.response);
  }
);

export const Get = (url, params = {}, clearFn) =>
  new Promise((resolve) => {
    axios
      .get(url, { params })
      .then((result) => {
        let res;
        // console.log(`${url}`, result.data)
        if (clearFn !== undefined) {
          res = clearFn(result.data);
        } else {
          res = result.data;
        }
        // resolve([null, res]);
        resolve(res);
      })
      .catch((err) => {
        // resolve([err, undefined]);
        resolve(err);
      });
  });

export const Post = (url, data, params = {}) => {
  return new Promise((resolve) => {
    axios
      .post(url, data, { params })
      .then((result) => {
        // resolve([null, result.data]);
        resolve(result.data);
      })
      .catch((err) => {
        // resolve([err, undefined]);
        resolve(err);
      });
  });
};
